module.exports = __webpack_public_path__ + "static/media/icon.3eea11c8.png";